// image slideshow
export function activatePopup(items, index) {
  console.log("hi activatePopup");

  const popupItems = items.map((i) => ({
    src: i.large,
    caption: generateCaption(i),
    link: `<a target="_blank" href="/images/${i.id}" title="edit image in a new window">✍️<span></span></a>`,
  }));

  console.log("popupItems", popupItems);
  console.log("index", index);

  // magnificPopup requires an element, so make a temporary one
  if (!$(".image-uploader-popup-div").length)
    $("body").append("<div class='image-uploader-popup-div'></div>");

  // new gallery is instantiated every time the user clicks on an image
  $(".image-uploader-popup-div")
    .magnificPopup({
      items: popupItems,
      gallery: {
        enabled: true,
      },
      index,
      showCloseBtn: true,
      closeOnBgClick: false,
      closeBtnInside: false,
      type: "image", // this is default type
      image: {
        // options for image content type
        markup:
          '<div class="mfp-figure">' +
          '<div class="mfp-image-wrap"><div class="mfp-img"></div></div>' +
          '<div class="mfp-bottom-bar">' +
          '<div class="mfp-contents-wrap">' +
          '<div class="mfp-caption"></div>' +
          '<div class="mfp-link"></div>' +
          "</div>" +
          "</div>" +
          "</div>", // Popup HTML markup. `.mfp-img` div will be replaced with img tag, `.mfp-close` by close button
      },
    })
    .magnificPopup("open");
}

function generateCaption(image) {
  const { caption, credit, description } = image;
  const captionDiv = caption
    ? `<div class="image-popup-caption">${caption}</div>`
    : "";
  const creditDiv = credit
    ? `<div class="image-popup-credit">${credit}</div>`
    : "";
  const descriptionDiv = description
    ? `<div class="image-popup-description">${description}</div>`
    : "";

  return `
    <div class="image-popup-caption-area">
      ${captionDiv}${creditDiv}${descriptionDiv}
    </div>
  `;
}
